import placeholder from "./default";
import newbot from "./newbot";
import algotrading from "./algotrading";
import goldenbot from "./goldenbot";
import quantifique from "./quantifique";
import benndorf from "./benndorf";
import capitalize from "./capitalize";
import quantic from "./quantic";
import poupabot from "./poupabot";
import winnerbot from "./winnerbot";
import linchen from "./linchen";
import agilebot from "./agilebot";
import casaltrader from "./casaltrader";
import primebot from "./primebot";
import rhodium from "./rhodium";
import oriontrading from "./oriontrading";
import traderbot from "./traderbot";
import robstrader from "./robstrader";
import rpalgoinvestimentos from "./rpalgoinvestimentos";
import jonasmarchioro from "./jonasmarchioro";
import findmoney from "./findmoney";
import robobolsa from "./robobolsa";
import qgdotrader from "./qgdotrader";
import mendesteodo from "./mendesteodo";
import vdtinvest from "./vdtinvest";
import ninetrader from "./ninetrader";
import numerica from "./numerica";
import renatomarinho from "./renatomarinho";
import frantiescoporto from "./frantiescoporto";
import ssbot from "./ssbot";
import cloudtrading from "./cloudtrading";
import northtrader from "./northtrader";
import itrade from "./itrade";
import infratecia from "./infratecia";
import mrrobots from "./mrrobots";
import asimov from "./asimov";
import universoquant from "./universoquant";
import beeinvesttech from "./beeinvesttech";
import quantse from "./quantse";
import sniperb3s from "./sniperb3s";
import trademachine from "./trademachine";
import barbatrader from "./barbatrader";
import factory4 from "./factory4";
import thiagoalvarenga from "./thiagoalvarenga";
import algoritmia from "./algoritmia";
import trade2go from "./trade2go";
import robosinvestidores from "./robosinvestidores";
import r2b3 from "./r2b3";
import veedhainvestimentos from "./veedhainvestimentos";
import cody from "./cody";
import arkhamasylum from "./arkhamasylum";
import mrmtrader from "./mrmtrader";
import i9robos from "./i9robos";
import hubdoinvestidor from "./hubdoinvestidor";
import dreambots from "./dreambots";
import smartbull from "./smartbull";
import futuroja from "./futuroja";
import oinvestidorquant from "./investidorquant";
import malkainvestimentos from "./malkainvestimentos";
import iacash from "./iacash";
import sigmasix from "./sigmasix";
import skytrader from "./skytrader";
import tekton from "./tekton";
import tradefacil from "./tradefacil";
import marrua from "./marrua";
import bnjanalytics from "./bnjanalytics";
import konig from "./konig";
import robotizztradersolutions from "./robotizztradersolutions";
import velocash from "./velocash";
import phdassets from "./phdassets";
import vqltradingquantitativo from "./vqltradingquantitativo";
import midasta from "./midasta";
import _8remora from "./8remora";
import kodtrading from "./kodtrading";
import topgain from "./topgain";
import odevquant from "./odevquant";
import fortiumbot from "./fortiumbot";
import darakmana from "./darakmana";
import outliersinvest from "./outliersinvest";
import quantroots from "./quantroots";
import growinvestimentos from "./growinvestimentos";
import _3pinvesting from "./3pinvesting";
import alphaquant from "./alphaquant";
import leprechaun from "./leprechaun";
import robotz from "./robotz";
import polvoinvest from "./polvoinvest";
import gptrading from "./gptrading";
import h9kquant from "./h9kquant";
import akhi from "./akhi";
import felipebaranska from "./felipebaranska";
import cloudalfa from "./cloudalfa";
import rp8trade from "./rp8trade";
import stratx from "./stratx";
import _5hundred from "./5hundredboot";
import incentivanegocios from "./incentivanegocios";
import multiflow from "./multiflow";
import xquant from "./xquant";
import mechanixtrading from "./mechanixtrading";
import selfinvest from "./selfinvest";
import brtrtecnologia from "./brtrtecnologia";
import alphamonkeyclub from "./alphamonkeyclub";
import trademetric from "./trademetric";
import nerotecnologia from "./nerotecnologia";
import eroscapitaltrading from "./eroscapitaltrading";
import quantlabs from "./quantlabs";
import copyautosync from "./copyautosync";
import mktech from "./mktech";

export default {
  mktech,
  copyautosync,
  quantlabs,
  eroscapitaltrading,
  nerotecnologia,
  trademetric,
  alphamonkeyclub,
  brtrtecnologia,
  selfinvest,
  mechanixtrading,
  xquant,
  multiflow,
  incentivanegocios,
  _5hundred,
  stratx,
  rp8trade,
  cloudalfa,
  akhi,
  felipebaranska,
  polvoinvest,
  h9kquant,
  gptrading,
  leprechaun,
  robotz,
  alphaquant,
  placeholder,
  newbot,
  algotrading,
  goldenbot,
  quantifique,
  benndorf,
  capitalize,
  quantic,
  poupabot,
  winnerbot,
  linchen,
  agilebot,
  casaltrader,
  primebot,
  rhodium,
  oriontrading,
  traderbot,
  robstrader,
  rpalgoinvestimentos,
  jonasmarchioro,
  findmoney,
  robobolsa,
  qgdotrader,
  mendesteodo,
  vdtinvest,
  ninetrader,
  numerica,
  renatomarinho,
  frantiescoporto,
  ssbot,
  cloudtrading,
  northtrader,
  itrade,
  infratecia,
  mrrobots,
  asimov,
  universoquant,
  beeinvesttech,
  quantse,
  sniperb3s,
  trademachine,
  barbatrader,
  factory4,
  thiagoalvarenga,
  algoritmia,
  trade2go,
  robosinvestidores,
  r2b3,
  veedhainvestimentos,
  cody,
  arkhamasylum,
  mrmtrader,
  i9robos,
  hubdoinvestidor,
  dreambots,
  smartbull,
  futuroja,
  oinvestidorquant,
  malkainvestimentos,
  iacash,
  sigmasix,
  skytrader,
  tekton,
  tradefacil,
  marrua,
  bnjanalytics,
  konig,
  robotizztradersolutions,
  velocash,
  phdassets,
  vqltradingquantitativo,
  midasta,
  _8remora,
  kodtrading,
  topgain,
  odevquant,
  fortiumbot,
  darakmana,
  outliersinvest,
  quantroots,
  growinvestimentos,
  _3pinvesting,
};
